export const categoryColors = [
  '#3A3934',
  '#787774',
  '#548164',
  '#976D57',
  '#CC782F',
  '#C29343',
  '#F59656',
  '#F8AA3F',
  '#F38070',
  '#F27A77',
  '#F2737E',
  '#E5647B',
  '#C4554D',
  '#D37592',
  '#BA79A0',
  '#9E7CB0',
  '#8A67AB',
  '#B35488',
  '#487CA5',
  '#5385DA'
]
